import { TranslateHome } from '../../libraries/helpers';
import { useNavigate } from 'react-router-dom';
import { get as _get } from 'lodash';
import Auth from '../../data/auth-service';

// the PermRoute will enforce these checks but here we'll try to navigate the user so he gets home
function useGoHome () {
    const navigate = useNavigate();

    return async user => {
        const license = await Auth.validateLicense();
        const eula = _get(user, 'data.profile.hide_eula', false);
        const password = user.password_expired !== true;
        let home = TranslateHome(_get(user, 'data.profile.home', '/support'));
        const althome = '/support';

        const perms = {
            dashboards: Auth.permissions.get('Dashboards'),
            alerts: Auth.permissions.get('Alerts'),
            metadata: Auth.permissions.get('Metadata'),
            sensors: Auth.permissions.get('Sensors'),
            users: Auth.permissions.get('Users'),
            roles: Auth.permissions.get('Roles'),
            audit: Auth.permissions.get('Audit')
        };

        // make sure user has permissions to his home page before we try to go there
        switch (user.data.profile.home) {
            case '/dashboard':
                if (!perms.dashboards.read) home = althome;
                break;
            case '/views/alerts':
            case '/alerts':
                if (!perms.alerts.read) home = althome;
                break;
            case '/views/metadata':
            case '/metadata':
                if (!perms.metadata.read) home = althome;
                break;
            case '/sensors':
                if (!perms.sensors.read) home = althome;
                break;
            case '/system/users_roles':
            case '/users':
                if (!(perms.users.read || perms.roles.read)) home = althome;
                break;
            case '/system/audit':
            case '/audit':
                if (!perms.audit.read) home = althome;
        }

        // start the long and winding road home
        // license -> password -> eula -> home
        const stack = [];
        stack.push(TranslateHome(home));
        if (!eula) stack.push('/support/eula');
        if (!password) stack.push(`/system/users_roles/password/${user.username}`);
        if (!license && process.env.BRICATA_APPLIANCE_TYPE !== 'mc2') stack.push('/system/license');

        const popped = stack.pop();
        navigate(popped, { replace: true, state: { next: stack } });
    };
}

export default useGoHome;
